import React from 'react';

import MenuIcon from '@mui/icons-material/Menu';
import { AppBarProps as MUIAppBarProps } from '@mui/material/AppBar';

import {
  IconButton,
  StyledAppBar,
  Toolbar,
  ToolContainer,
} from './index.styles';

interface AppBarProps extends MUIAppBarProps {
  onDrawerButtonClick: () => void,
  drawerOpen: boolean,
}

const AppBar = ({ onDrawerButtonClick, drawerOpen,
  ...rest }: AppBarProps) =>
  (
    <StyledAppBar {...rest}>
      <Toolbar>
        <ToolContainer $showBackground={!drawerOpen}>
          <IconButton
            size="medium"
            edge="start"
            color="inherit"
            aria-label="menu"
            disableRipple
            onClick={onDrawerButtonClick}
          >
            <MenuIcon />
          </IconButton>
        </ToolContainer>
      </Toolbar>
    </StyledAppBar>
  );

export default AppBar;
